import axios from "axios";
import { getStoredDeviceId } from "@/contexts/GuestContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 150000 });

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const token = localStorage.getItem("sux1_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Always send the device id so endpoints that accept both auth modes
  // (/summarize/stream, /summarize/reduce, /billing/me) can resolve the
  // caller even when there is no Bearer token. The backend prefers the
  // token when both are present, so authenticated users are unaffected.
  try {
    const deviceId = getStoredDeviceId();
    if (deviceId) config.headers["X-Device-Id"] = deviceId;
  } catch {
    /* ignore */
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data;
    if (d && typeof d.detail === "string") d.detail = d.detail.replace(/\s*—\s*code=ai_daily_limit/, "");
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      // Only invalidate + bounce to /login if the user had a token (they
      // used to be authenticated and their session expired). Anonymous
      // visitors must stay on the Dashboard — guest flow handles their
      // 402/429 responses locally without redirecting away.
      const hadToken = !!localStorage.getItem("sux1_token");
      if (hadToken && path !== "/login" && path !== "/signup") {
        localStorage.removeItem("sux1_token");
        localStorage.removeItem("sux1_user");
        window.location.assign("/login");
      }
    }
    return Promise.reject(err);
  }
);
